module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2-1"
  }, [_c('a', {
    attrs: {
      "id": "page_V"
    }
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "Contents_toc_1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Preface#rContents_toc_1"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "Contents_toc_2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgement#rContents_toc_2"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "Contents_toc_3"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter1#rContents_toc_3"
    }
  }, [_c('b', [_vm._v("1 Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "Contents_toc_4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter2#rContents_toc_4"
    }
  }, [_c('b', [_vm._v("2 The Basics of Weight Training")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "Contents_toc_5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter3#rContents_toc_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3 In the Weight Room")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "Contents_toc_6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter4#rContents_toc_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4 Program Information")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "Contents_toc_7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter5#rContents_toc_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5 Program Design")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "Contents_toc_8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter6#rContents_toc_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6 Stretching for Flexibility")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "Contents_toc_9"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter7#rContents_toc_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7 Lower-Body Exercises")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "Contents_toc_10"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter8#rContents_toc_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8 Upper-Body Exercises")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "Contents_toc_11"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter9#rContents_toc_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9 Core Exercises")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "Contents_toc_12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#rContents_toc_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10 Power Development")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2",
    attrs: {
      "id": "Contents_toc_13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11#rContents_toc_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11 Sample Program")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-3",
    attrs: {
      "id": "Contents_toc_14"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Appendix1#rContents_toc_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: Workout Sheet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-3",
    attrs: {
      "id": "Contents_toc_15"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Appendix2#rContents_toc_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: Blank Periodized Schedule")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-3",
    attrs: {
      "id": "Contents_toc_16"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Reference#rContents_toc_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References and Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-3",
    attrs: {
      "id": "Contents_toc_17"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Abouttheauthor#rContents_toc_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-3",
    attrs: {
      "id": "Contents_toc_18"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Index#rContents_toc_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 72
// module chunks = 0